import { t } from 'ttag';

const SUPPORT_REQUEST_TYPE_ENUM = {
  ReportRequest: 'ReportRequest',
  ChangeStudyType: 'ChangeStudyType',
  AbortStudy: 'AbortStudy',
  WebPortalIssues: 'WebPortalIssues',
  BillingQuestions: 'BillingQuestions',
  Other: 'Other',
  ChangeStudyInformation: 'ChangeStudyInformation',
};

const {
  ReportRequest,
  ChangeStudyType,
  AbortStudy,
  WebPortalIssues,
  BillingQuestions,
  Other,
  ChangeStudyInformation,
} = SUPPORT_REQUEST_TYPE_ENUM;

const SUPPORT_REQUEST_TYPE = {
  [ReportRequest]: t`Report request`,
  [ChangeStudyType]: t`Change study type`,
  [AbortStudy]: t`Abort study`,
  [ChangeStudyInformation]: t`Change study information`,
  [WebPortalIssues]: t`Web portal issues`,
  [BillingQuestions]: t`Billing questions`,
  [Other]: t`Others`,
};

export { SUPPORT_REQUEST_TYPE_ENUM, SUPPORT_REQUEST_TYPE };
